module.exports = __webpack_public_path__ + "img/pause-button.8a3f34d7.svg";